// import { SessionStorageItems } from "services/user/user.session.service";
// import { setItemStorage } from "services/util/sessionStorage.service";
import { PlanningObj } from "../TripSelectorTrain.model";

// export const manageSubHeaderPlanner = (ev: CustomEvent, returnStep: number, t: Function): { action: string, obj: any } => {
//     let body = ev.detail;
//     const { ok, msg } = checkBookingDates(body, t, returnStep == 2);
//     if (ok) {
//         let obj = body;
//         const objMapped: PlanningObj = mapPlanningObject(obj);
//         if (returnStep == 2) {
//             obj = invertBodyData(body)
//         };
//         _makeTravellersList(body);
//         setItemStorage(SessionStorageItems.TRIP, objMapped);
//         return { action: 'call', obj };
//     } else {
//         return { action: 'update', obj: { body, msg } };
//     }
// }

export const mapPlanningObject = (obj: PlanningObj): PlanningObj => {
    delete obj.destination.value.productAtStop;
    delete obj.origin.value.productAtStop;
    // obj.return = obj.arrivalDate.invalid || !obj.arrivalDate.value ? false : true;
    return obj;
}

export const _makeTravellersList = (planningObject: PlanningObj) => {
    const passengersList = planningObject?.passengers?.value;
    const passengerMapped = {
        adult: Array(passengersList["more-than-13-counter"]).fill({
            type: "ADULT",
        }),
        child: Array(passengersList["less-than-13-counter"]).fill({
            type: "CHILD",
        }),
        baby: Array(passengersList["less-than-3-counter"]).fill({ type: "BABY" }),
    };
    const travellersBody = passengerMapped?.adult.concat(
        passengerMapped?.child,
        passengerMapped?.baby
    );
    // setTravellersList(travellersBody);
    return travellersBody;
};

export const invertBodyData = (body: PlanningObj): PlanningObj => {
    let aux = { ...body };
    const data: PlanningObj = {
        ...body,
        origin: aux.destination,
        destination: aux.origin,
        arrivalDate: aux.departureDate,
        arrivalSchedule: aux.departureSchedule,
        departureDate: aux.arrivalDate,
        departureSchedule: aux.arrivalSchedule,
        trip: 'RETURN'
    };
    // console.log({ invertBodyData: data });
    return data;
};

const checkBookingDates = (details: any, t?: any, inverse?: boolean) => {
    let ok = true;
    let msg = "";
    let { hours, minutes } = details?.departureSchedule?.value;
    let departureDate = new Date(details?.departureDate?.value);
    let departureFullDate = new Date(departureDate.getFullYear(), departureDate.getMonth(), departureDate.getDate(), parseInt(hours), parseInt(minutes));
    let actualDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), new Date().getHours(), new Date().getMinutes());

    if (!details.return) {
        ok = departureFullDate >= actualDate;
        if (!ok) msg = t("literals.previousDepartureDateCurrentDate");
    } else {
        hours = details?.arrivalSchedule?.value.hours;
        minutes = details?.arrivalSchedule?.value.minutes;
        let arrivalDate = new Date(details?.arrivalDate?.value);
        let arrivalFullDate = new Date(arrivalDate.getFullYear(), arrivalDate.getMonth(), arrivalDate.getDate(), parseInt(hours), parseInt(minutes));
        ok = (arrivalFullDate > departureFullDate) && (departureFullDate >= actualDate);
        if (!(arrivalFullDate > departureFullDate)) msg = t("literals.previousArrivalDateDepartureDate");
        if (inverse && (arrivalFullDate > departureFullDate)) msg = t("literals.previousArrivalDateDepartureDate");
        if (!(departureFullDate >= actualDate)) msg = t("literals.previousDepartureDateCurrentDate");
    }

    return { ok: inverse ? !ok : ok, msg };
}

export const _checkisPastDate = (date: string | Date, hours: number, minutes: number) => {
    const dateNow = new Date();

    const dateSelectNow = new Date(date);
    dateSelectNow.setHours(hours);
    dateSelectNow.setMinutes(minutes);

    let _date = dateSelectNow;

    var hourAux = "", minuteAux = "";
    if (dateSelectNow) {
        //Si es el mismo dia aplicamos logica de la hora pasada
        if (dateNow.getDate() == dateSelectNow.getDate()) {
            if (dateSelectNow >= dateNow) {
                //"Hora marcada es mayor que la hora real, ponemos la hora seleccionada
                hourAux = addZerosLeft(hours);
                minuteAux = addZerosLeft(minutes);
            } else {
                //Ponemos la hora actual
                hourAux = addZerosLeft(dateNow.getHours());
                minuteAux = addZerosLeft(dateNow.getMinutes());
            }
            _date = dateSelectNow;
        } else {
            //Si dia marcado no es el mismo no hacemos nada
            hourAux = addZerosLeft(hours);
            minuteAux = addZerosLeft(minutes);
        }
    }
    return { hours: hourAux, minutes: minuteAux, date: _date };
}
export function addZerosLeft(n: any) {
    n = n + '';
    return n.length >= 2 ? n : new Array(2 - n.length + 1).join('0') + n;
};